import { render, staticRenderFns } from "./SiViewV2.vue?vue&type=template&id=617d41c0&scoped=true&"
import script from "./SiViewV2.vue?vue&type=script&lang=js&"
export * from "./SiViewV2.vue?vue&type=script&lang=js&"
import style0 from "./SiViewV2.vue?vue&type=style&index=0&id=617d41c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617d41c0",
  null
  
)

export default component.exports